import { useEffect } from "react";


export const useKeyDownOnPress=(handleSubmit:()=>void)=>{
    useEffect(() => {
        const handleKeyDown = (event:any) => {
          if (event.key === "Enter") {
            handleSubmit();
          }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => {
          document.removeEventListener("keydown", handleKeyDown);
        };
      }, [handleSubmit]);

}